export default {
	notification_health: 'Meldingstatus',
	notification_health_summary: 'Samenvatting',
	notification_health_loading: 'Meldingstatus controleren...',
	notification_health_refresh: 'Vernieuwen',
	notification_health_fix: 'Wat te doen',
	notification_health_unavailable: 'Meldingstatus kon niet worden geladen',
	notification_health_healthy: 'Gezond',
	notification_health_blocked: 'Geblokkeerd',
	notification_health_degraded: 'Vereist aandacht',
	notification_health_no_app_user: 'Geen app-login',
	notification_health_unknown: 'Onbekend',
	notification_health_app_version: 'App-versie',
	notification_health_last_delivery: 'Laatste levering',
	notification_health_time_just_now: 'zojuist',
	notification_health_time_minutes: '{count} minuut/minuten geleden',
	notification_health_time_hours: '{count} uur geleden',
	notification_health_time_days: '{count} dag(en) geleden',
	notification_health_time_unknown: 'onbekend',
	notification_health_summary_healthy: 'Meldingen zouden moeten werken',
	notification_health_summary_no_app_user: 'Schoonmaker is niet ingelogd in de mobiele app',
	notification_health_summary_blocked_no_token: 'Push-token ontbreekt — schoonmaker moet de app openen en inloggen',
	notification_health_summary_blocked_off: 'Meldingen zijn uitgeschakeld in de app',
	notification_health_check_portal_contact_label: 'Portalcontact bestaat',
	notification_health_check_portal_active_label: 'Contact is actief',
	notification_health_check_portal_rooms_label: 'Kamers toegewezen',
	notification_health_check_portal_shifts_label: 'Diensten toegewezen',
	notification_health_check_app_user_label: 'Ingelogd in mobiele app',
	notification_health_check_push_token_label: 'Push-token geregistreerd',
	notification_health_check_notification_mode_label: 'Meldingsmodus',
	notification_health_check_time_schedule_label: 'Binnen meldingstijdvenster',
	notification_health_check_ios_geo_filter_label: 'iOS-locatiefilter',
	notification_health_check_recent_push_attempt_label: 'Recente push-poging (48u)',
	notification_health_check_last_push_ignored_label: 'Laatste signaal is niet verzonden',
	notification_health_check_recent_push_delivered_label: 'Recente push geleverd (48u)',
	notification_health_detail_portal_contact_found: 'Gevonden in portal',
	notification_health_detail_portal_contact_missing: 'Geen contactrecord gevonden',
	notification_health_detail_portal_active_active: 'Actief',
	notification_health_detail_portal_active_inactive: 'Inactief',
	notification_health_detail_portal_rooms_assigned: '{count} kamer(s)',
	notification_health_detail_portal_rooms_none: 'Geen kamers toegewezen',
	notification_health_detail_portal_shifts_assigned: '{count} dienst(en)',
	notification_health_detail_portal_shifts_none: 'Geen diensten toegewezen',
	notification_health_detail_app_user_logged_in: 'App-versie {version}, laatste synchronisatie {lastSync}',
	notification_health_detail_app_user_never: 'Nooit ingelogd',
	notification_health_detail_push_token_present: 'FCM-token aanwezig',
	notification_health_detail_push_token_empty: 'Token is leeg',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Huidige tijd valt binnen schema',
	notification_health_detail_time_schedule_outside: 'Huidige tijd valt buiten geconfigureerd schema',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Geen push-pogingen in afgelopen 48 uur',
	notification_health_detail_last_push_ignored: 'Laatste pushverzoek is genegeerd (servik niet geconfigureerd voor werkgebied)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Geen succesvolle leveringen in afgelopen 48 uur',
	notification_health_fix_portal_contact: 'Maak deze schoonmaker aan in het gebruikerspaneel',
	notification_health_fix_portal_active: 'Schakel de schakelaar Actief in voor deze schoonmaker',
	notification_health_fix_portal_rooms: 'Wijs minstens één kamer toe aan deze schoonmaker',
	notification_health_fix_portal_shifts: 'Wijs minstens één dienst toe',
	notification_health_fix_app_user: 'Schoonmaker moet de app installeren en inloggen met dit telefoonnummer',
	notification_health_fix_push_token: 'Vraag de schoonmaker de app te openen, meldingen toe te staan in iOS-instellingen en opnieuw in te loggen',
	notification_health_fix_notification_mode: 'Wijzig meldingsmodus van Uit naar Altijd in de app',
	notification_health_fix_time_schedule: 'Wacht tot het geplande venster of wijzig modus naar Altijd',
	notification_health_fix_ios_geo_filter: 'Schoonmaker is buiten meldingszone — vraag om de app ter plaatse te openen',
	notification_health_fix_last_push_ignored: 'Controleer servik-configuratie voor werkgebied van de kamer die het signaal activeerde',
	notification_health_fix_recent_push_delivered_filters: 'Controleer meldingsfilters of apparaatinstellingen',
	notification_health_fix_recent_push_delivered_token: 'Registreer eerst push-token',
	notification_health_mode_on: 'Altijd',
	notification_health_mode_off: 'Uit',
	notification_health_mode_time: 'Op tijd',
	notification_health_mode_location: 'Op locatie',
	notification_health_filter_on: 'Aan',
	notification_health_filter_off: 'Uit',
};
